import React from 'react';

const JS_Canvas = () => {
  return (
    <div >
      <h1>JS_Canvas</h1>
      <p>Placeholder component for: "JS Canvas"</p>
    </div>
  );
};

export default JS_Canvas;
